import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { StyledTypography, StyledCard, StyledCardContent } from '../styles/styles';

interface EntityLookupStepProps {
  onComplete: () => void;
}

export const EntityLookupStep: React.FC<EntityLookupStepProps> = ({ onComplete }) => {
  React.useEffect(() => {
    // Simulate lookup process
    const timer = setTimeout(() => {
      onComplete();
    }, 1000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <StyledCard tone="tone1">
      <StyledCardContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 6 }}>
          <CircularProgress size={60} sx={{ mb: 3 }} />
          <StyledTypography>Looking up existing investment entities...</StyledTypography>
        </Box>
      </StyledCardContent>
    </StyledCard>
  );
};
